<template>
  <div class="container-fluid component">
    <div>
      <p class="h4 heading welcomeHeader">
        Welcome!<help v-if="existingUser" :portal="portal" class="pull-right padding-80" />
      </p>
      <p class="welcome-text">Please enter your e-mail address to get started.</p>
      <form novalidate class="form-inline" @submit.prevent="submitForm">
        <div class="form-group">
          <input
            id="email"
            ref="email"
            v-model.trim="user.email"
            v-focus
            :disabled="showEditEmailBtn"
            type="email"
            placeholder="example@domain.com"
            class="form-control"
            @blur="$v.user.email.$touch();"
          />
          <button v-if="!showEditEmailBtn" :disabled="loading" type="submit" class="btn btn-sm btn-primary">
            Go <i v-show="loading" class="fa fa-spinner fa-spin"></i>
          </button>
          <!-- change email button -->
          <input v-if="showEditEmailBtn" class="btn btn-sm btn-link" value="Clear" @click="enableEdit" />
        </div>
        <div v-if="!$v.user.email.email && $v.user.email.$error" class="text-danger input-error">
          Enter a valid e-mail address
        </div>
        <div v-if="!$v.user.email.required && $v.user.email.$error" class="text-danger input-error">
          Enter e-mail address
        </div>
        <div v-if="!$v.user.email.maxLength && $v.user.email.$error" class="text-danger input-error">
          Allowed upto 150 characters only
        </div>
      </form>
      <div v-if="showResumeDraftMsg" class="company-list">
        <p>
          <a href="#" @click="goToResumedraft"
            ><span class="fa fa-info-circle fa-sm" /> We can see you already started filling out a form and we saved it,
            if you would like to resume that, please click here.</a
          >
        </p>
      </div>
    </div>
    <existing-user v-if="existingUser && !accountSuspended" />
    <suspended-user v-if="accountSuspended" />
    <div v-if="showCompanyList && companies.length" class="company-list">
      <p>
        Your e-mail address matches the following companies or organizations. For which <br />
        company do you work? Select from the list below.
      </p>
      <company-list :companies="companies" :portal="portal" />
    </div>
    <div v-if="showCompanyList" class="company-list">
      <p v-if="companies.length">
        None of the above? Try a different e-mail address above, or type three or more characters <br />
        of your company name below.
      </p>
      <p v-else class="non-existing">
        Your e-mail address did not match any of our existing companies or organizations. Try a <br />
        different e-mail address above, or type three or more characters of your company name <br />
        below.
      </p>
      <company-search :portal="portal" />
    </div>
  </div>
</template>
<script>
import companyList from "./CompanyList";
import companySearch from "./CompanySearch";
import existingUser from "./../components/ExistingUser";
import suspendedUser from "./../components/SuspendedUser";
import { checkUserExists } from "@/services/endpointsService";
import { mapState } from "vuex";
import { email, required, maxLength } from "vuelidate/lib/validators";
import help from "./HelpInfo";

export default {
  components: {
    companyList,
    companySearch,
    existingUser,
    suspendedUser,
    help
  },
  props: {
    portal: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      query: "",
      companies: [],
      loading: false,
      showCompanyList: false,
      showEditEmailBtn: false,
      existingUser: false,
      accountSuspended: false,
      reactivateUserModal: false,
      showResumeDraftMsg: false
    };
  },
  computed: {
    ...mapState("user", ["user"]),
    isGEUser() {
      return this.user.email.toLowerCase().endsWith("@ge.com") || this.$store.state.user.user.mdmOrgZone == "INC";
    }
  },
  created() {
    this.existingUser = false;
  },
  methods: {
    submitForm() {
      //reset data and flags before submit
      this.existingUser = false;
      this.accountSuspended = false;
      this.companies.length = 0;
      this.showCompanyList = false;
      this.showResumeDraftMsg = false;
      this.query = "";
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      let isGEUser = this.user.email.toLowerCase().endsWith("@ge.com");
      let isSafranSnecmaUser =
        this.user.email.toLowerCase().endsWith("@safrangroup.com") ||
        this.user.email.toLowerCase().endsWith("@snecma.com");
      this.$store.dispatch("user/setIsGeUser", isGEUser);

      // check user exists
      this.loading = true;
      checkUserExists(this.user.email)
        .then(data => {
          this.$store.dispatch("user/updateOrgZone", data.orgZone);
          if (data.accountExists) {
            this.existingUser = data.accountExists;
            this.accountSuspended = data.accountSuspended;
            this.showEditEmailBtn = true;
          } else if (isGEUser || isSafranSnecmaUser) {
            this.$store.dispatch("user/setActivePage", "requestAccessPage");
          } else {
            this.showEditEmailBtn = true;
            this.companies = data.companyList;
            this.showCompanyList = true;
          }
          if (data.draftAvailable) {
            this.showResumeDraftMsg = true;
          }
        })
        .catch(() => {})
        .finally(() => {
          // hide spinner
          this.loading = false;
        });
    },
    enableEdit() {
      this.user.email = "";
      // reset validator to avoid showing error message when email is cleared
      this.$v.$reset();
      this.accountSuspended = false;
      this.existingUser = false;
      this.showEditEmailBtn = false;
      // hide company list
      this.showCompanyList = false;
      this.showResumeDraftMsg = false;
      this.companies.length = 0;
      this.$refs.email.focus();
    },
    resumeDraft() {
      this.$router.push("resume-draft");
    },
    goToResumedraft() {
      this.$router.push("/resume-draft?email=" + this.user.email);
    }
  },
  validations: {
    user: {
      email: {
        email,
        required,
        maxLength: maxLength(150)
      }
    }
  }
};
</script>
<style lang="less" scoped>
.component {
  padding-bottom: 50px;
}

.form-inline .form-control {
  display: inline-block !important;
}

#email {
  margin-right: 15px;
  width: 260px;

  + .btn {
    width: 50px;
    width: 50px;
  }
}

.company-list {
  p {
    margin-top: 30px;
  }
}
.btn-resume-draft {
  margin-top: 3px;
}
.non-existing {
  clear: both;
  padding-top: 5px;
  width: 570px;
  background-color: rgb(247, 248, 250);
  display: block;
}

.modal-header {
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 18px;
  background-color: #edeeef;
}
.modal-data {
  overflow-y: auto;
  max-height: 400px;
  line-height: 2;
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 12px;
  font-weight: normal;
  color: #000000;
  text-align: justify;
}

.modal-footer {
  border-top-color: #e1e2e5;
}

.welcomeHeader {
  font-size: 23px;
  font-weight: bold;
  color: #004bbd;
  font-family: apexSans;
}
</style>
